export default "/assets/images/mamatobe-filter.345f9d627fe337ee.png";